<router>
{
    name: 'Customers',
}
</router>
<template lang="pug">
v-container(fluid)
    v-row
        v-col(cols='8')
            DevopsDownloadClient

</template>
<script>

import DevopsDownloadClient from '@/components/devops/downloadClient';
export default {
    meta: {
        role: 'devopsdownloadclient'
    },
    components: {
        DevopsDownloadClient
    },
    data () {
        return {
        };
    },
    methods: {

    },
    computed: {

    },
    mounted () {
    }
};
</script>

<style scoped>
</style>
